import React, { useEffect, useState } from "react";
import TopNavigation from "./TopNavigation";
import Sidebar from "./Sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useSession from "../../hooks/useSession";

function Layout() {
  const [isSidenavClosed, setIsSidenavClosed] = useState(true);
  const [darkMode, setDarkMode] = useState(false);
  const navigate = useNavigate();
  const [user] = useSession();

  // menu toggle
  function toggleHamburger() {
    setIsSidenavClosed((old) => !old);
  }

  // Dark mode toggle
  function toggleDarkMode() {
    setDarkMode((old) => !old);
  }
  useEffect(() => {
    const isDarkMode = localStorage.getItem("theme") === "dark";
    setDarkMode(isDarkMode);
  }, []);
  useEffect(() => {
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);
  useEffect(() => {
    if (
      localStorage.theme === "dark" ||
      (!("theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme: dark)").matches)
    ) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);
  // Dark mode toggle End

  // LOGOUT handler - clear from session and navigate to login page
  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <main className="flex flex-row relative">
      <Sidebar
        isSidenavClosed={isSidenavClosed}
        darkMode={!darkMode}
        handleLogout={handleLogout}
      />
      <div className="w-full max-h-screen overflow-y-auto ">
        <TopNavigation
          toggleHamburger={toggleHamburger}
          toggleDarkMode={toggleDarkMode}
          handleLogout={handleLogout}
          darkMode={!darkMode}
          user={user}
        />
        {/* Body section */}
        <div className="bg-primary dark:bg-darkModeBg dark:text-darkWhite transition-colors duration-100 min-h-full">
          <div className="h-auto min-h-screen p-2">
            <Outlet />
            <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </div>
        </div>
      </div>
    </main>
  );
}

export default Layout;
